import { render, staticRenderFns } from "./StatNumbers.vue?vue&type=template&id=61fdfe4f&"
import script from "./StatNumbers.vue?vue&type=script&lang=js&"
export * from "./StatNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports